
import React from 'react'

export default function PolygonGreenFilled() { return (<svg width="77" height="77" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M75.8662 1.3623L75.8662 75.2453L1.83549 1.3623L75.8662 1.3623Z" fill="#07BDBD" stroke="#07BDBD"/>
</svg>)}
